import {
  OneTimePaymentSuccessArgs,
  PaymentIntent,
  StripeInvoice,
  PayStripeInvoice,
  ClientSecret,
  InvoiceWithPaymentInformation,
} from "../types";
import { patientApi } from "./patientApi";
import { TAG } from "../constants";

export const paymentsApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    createCustomerSession: builder.query<{ token: string }, void>({
      query: () => ({
        method: "GET",
        url: "/api/patient/payment-methods/session",
      }),
    }),
    verifyCheckoutSession: builder.mutation<{ is_valid: boolean }, string>({
      query: (checkoutSessionId) => ({
        method: "POST",
        url: `/api/patient/checkout-sessions/${checkoutSessionId}/verify`,
      }),
    }),
    createSetupIntent: builder.mutation<ClientSecret, void>({
      query: () => ({
        method: "POST",
        url: "/api/patient/payment-methods/setup-intent",
      }),
      invalidatesTags: [TAG.PAYMENT_METHODS],
    }),
    createDraftInvoice: builder.mutation({
      query: (body) => ({
        method: "POST",
        url: "/api/stripe/draft-invoice",
        body,
      }),
    }),
    payInvoiceNow: builder.mutation<
      StripeInvoice,
      { invoiceId: string; paymentMethodId: string }
    >({
      query: ({ invoiceId, ...body }) => ({
        method: "POST",
        url: `/api/patient/invoices/${invoiceId}/pay`,
        body,
      }),
      invalidatesTags: [TAG.STRIPE],
    }),
    getPatientInvoices: builder.query<
      InvoiceWithPaymentInformation[],
      { status?: string }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/patient/invoices`,
        params,
      }),
      providesTags: [TAG.STRIPE],
    }),
    oneTimePayment: builder.mutation<
      {
        paymentIntent: PaymentIntent;
        invoice: PayStripeInvoice;
      },
      {
        priceId: string;
        paymentMethodId?: string;
        couponId?: number;
        quantity?: number;
      }
    >({
      query: (body) => ({
        method: "POST",
        url: "/api/patient/invoices/one-time",
        body,
      }),
    }),
    afterOneTimePaymentSuccess: builder.mutation<
      void,
      OneTimePaymentSuccessArgs
    >({
      query: (body) => ({
        method: "POST",
        url: "/api/patient/invoices/one-time-payment-success",
        body,
      }),
      invalidatesTags: [TAG.TASKS],
    }),
  }),
});

export const {
  useAfterOneTimePaymentSuccessMutation,
  useOneTimePaymentMutation,
  useGetPatientInvoicesQuery,
  usePayInvoiceNowMutation,
  useCreateSetupIntentMutation,
  useCreateDraftInvoiceMutation,
  useVerifyCheckoutSessionMutation,
  useCreateCustomerSessionQuery,
} = paymentsApi;
